import { GoodgamePartners } from "./../../../constants/GoodgamePartners";
import { SupportUtil } from "./../../../misc/SupportUtil";
import { BrowserUtil } from "./../../../utils/BrowserUtil";
import { EnvGlobalsHandler } from "../../EnvGlobalsHandler";
import { IEnvironmentGlobals } from "../../IEnvironmentGlobals";
import { BasicController } from "../BasicController";
import { BasicModel } from "../../model/BasicModel";
import { BasicUserData } from "../../model/components/BasicUserData";
import { CommandController } from "./../../../commanding/CommandController";
import { GGSCountryController } from "./../../../language/countryMapper/GGSCountryController";
import { URLRequest } from "@goodgamestudios/createjs-utilities";
import { getLogger } from "@goodgamestudios/logger";
const logger = getLogger("BasicContextMenuController");


// import ContextMenuEvent = createjs.ContextMenuEvent;  //TODO: @HTML5 unhandled ContextMenuEvent class
import ContextMenuEvent = createjs.Event;
import { commentedOut } from "../../../../../decorators";
import { BasicConstants } from "../../constants/BasicConstants";
// import System = createjs.System; //TODO: @HTML5 unhandled System class
// import ContextMenu = createjs.ContextMenu; //TODO: @HTML5 unhandled ContextMenu class
// import ContextMenu = createjs.ContextMenuItem; //TODO: @HTML5 unhandled ContextMenuItem class


export class BasicContextMenuController {
    public static FORUM_LABEL: string = "Forum";
    public static GGS_COPYRIGHT_LABEL: string = "(C) 2009-2016 Goodgame Studios";
    public static SUPPORT_LABEL: string = "Support";
    public static FACEBOOK_LABEL: string = "Facebook-Fansite";
    public static BLOG_LABEL: string = "Blog (our company blog)";

    private static _instance: BasicContextMenuController;
    // private _ggsContextMenu: ContextMenu = new ContextMenu(); //TODO: @HTML5 unhandled ContextMenu class
    private _ggsContextMenu: any;
    private _initialized: boolean = false;

    public static get instance(): BasicContextMenuController {
        if (!BasicContextMenuController._instance) {
            BasicContextMenuController._instance = new BasicContextMenuController();
        }

        return BasicContextMenuController._instance;
    }

    // public get ggsContextMenu(): ContextMenu { //TODO: @HTML5 unhandled ContextMenu class
    public get ggsContextMenu(): any {
        if (!this._initialized) {
            /* TODO: @HTML5 unhandled ContextMenuItem class
            this._ggsContextMenu.hideBuiltInItems();

            let xmlVersion: ContextMenuItem = new ContextMenuItem(this.env.versionText, false, true, true);
            let nameItem: ContextMenuItem = new ContextMenuItem(this.env.currentGameTitle, false, true, true);
            let ggsLink: ContextMenuItem = new ContextMenuItem(BasicContextMenuController.GGS_COPYRIGHT_LABEL, false, true);

            // Support link should be disabled for the SSO networks
            let supportLink: ContextMenuItem = new ContextMenuItem(BasicContextMenuController.SUPPORT_LABEL, true, this.contextMenuEnabled, true);
            let forumLink: ContextMenuItem = new ContextMenuItem(BasicContextMenuController.FORUM_LABEL, false, false, true);
            let facebookLink: ContextMenuItem = new ContextMenuItem(BasicContextMenuController.FACEBOOK_LABEL, false, this.contextMenuEnabled, true);
            let blogLink: ContextMenuItem = new ContextMenuItem(BasicContextMenuController.BLOG_LABEL, false, this.contextMenuEnabled, true);
            */

            /* TODO: @HTML5 unhandled ContextMenuEvent class
            ggsLink.addEventListener(ContextMenuEvent.MENU_ITEM_SELECT, this.onGgsLinkSelected);
            xmlVersion.addEventListener(ContextMenuEvent.MENU_ITEM_SELECT, this.onXmlVersionSelected);
            supportLink.addEventListener(ContextMenuEvent.MENU_ITEM_SELECT, this.onSupportSelected);
            forumLink.addEventListener(ContextMenuEvent.MENU_ITEM_SELECT, this.onForumSelected);
            facebookLink.addEventListener(ContextMenuEvent.MENU_ITEM_SELECT, this.onFacebookSelected);
            blogLink.addEventListener(ContextMenuEvent.MENU_ITEM_SELECT, this.onBlogSelected);

            this._ggsContextMenu.customItems.push(xmlVersion, nameItem, ggsLink, supportLink, forumLink, facebookLink, blogLink);

            this._initialized = true;
            */
        }

        return this._ggsContextMenu;
    }
    @commentedOut()
    public enableContextMenuItem(contextMenuItemCaption: string): void {
        if (!this.contextMenuEnabled) {
            return;
        }

        if (this._ggsContextMenu) {
            for (let contextMenuItem of this._ggsContextMenu.customItems) {
                if (contextMenuItem.caption === contextMenuItemCaption && !contextMenuItem.enabled) {
                    contextMenuItem.enabled = true;
                }
            }
        }
    }
    @commentedOut()
    public disableContextMenuItem(contextMenuItemCaption: string): void {
        if (!this.contextMenuEnabled) {
            return;
        }

        if (this._ggsContextMenu) {
            for (let contextMenuItem of this._ggsContextMenu.customItems) {
                if (contextMenuItem.caption === contextMenuItemCaption && contextMenuItem.enabled) {
                    contextMenuItem.enabled = false;
                }
            }
        }
    }

    @commentedOut()
    public refreshVersionInfo(): void {
        if (this._ggsContextMenu.customItems.length) {
            let customItems: any[] = this._ggsContextMenu.customItems;
            //TODO: @HTML5 unhandled ContextMenuItem class
            // ((<ContextMenuItem>customItems[0])).caption = this.env.versionText;
            this._ggsContextMenu.customItems = customItems;
        }
    }
    @commentedOut()
    public onXmlVersionSelected(event: ContextMenuEvent): void {
        // System.setClipboard(((<ContextMenuItem>event.target)).caption);
    }

    private onGgsLinkSelected(event: ContextMenuEvent): void {
        BrowserUtil.executeNavigateToURL(new URLRequest(BasicConstants.DOMAIN_PROTOCOL + "://www.goodgamestudios.com"), "_blank");
    }

    private onBlogSelected(event: ContextMenuEvent): void {
        BrowserUtil.executeNavigateToURL(new URLRequest(BasicConstants.DOMAIN_PROTOCOL + "://blog.goodgamestudios.com/"), "_blank");
    }

    private onFacebookSelected(event: ContextMenuEvent): void {
        BrowserUtil.executeNavigateToURL(new URLRequest(BasicConstants.DOMAIN_PROTOCOL + "://www.facebook.com/GoodgameStudios"), "_blank");
    }

    private onForumSelected(event: ContextMenuEvent): void {
        CommandController.instance.executeCommand(BasicController.COMMAND_OPEN_FORUM);
    }

    private onSupportSelected(event: ContextMenuEvent): void {
        let userName: string = BasicModel.userData.userName;

        // Don't send dummy-name, if user is not registered yet.
        if (userName === undefined) {
            userName = "";
        }

        SupportUtil.navigateToSupport(BasicModel.instanceProxy.selectedInstanceVO.instanceId, this.env.versionText, userName, BasicModel.userData.playerID, BasicModel.userData.userID, GGSCountryController.instance.currentCountry.ggsLanguageCode);
    }

    private get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    private get contextMenuEnabled(): boolean {
        return this.env.networkId === GoodgamePartners.NETWORK_GENERAL;
    }
}

